import React, { FC } from 'react';
import { UserInfo } from '../../../common/model/dto/user-info';
import OvClinicLocationUserListRow from './OvClinicLocationUserListRow';
import { useTranslation } from 'react-i18next';
import OvListTableRow from '../atoms/OvListTableRow';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvListTable from '../atoms/OvListTable';
import { OrderBy, SortDirection } from '../../../common/types';
import { UseMutationResult } from '@tanstack/react-query';

interface OvClinicLocationUserListProps {
  users: UserInfo[];
  clinicLocationId?: string;
  clinicId?: string;
  deleteAction?: UseMutationResult<any, Error, any, unknown>;
  deleteActionCtaLabel?: string;
  seeDetails?: boolean;
  seeDetailsCtaLabel?: string;
  showClinicRole?: boolean;
  showClinicLocationProviderCreatedAt?: boolean;
  showClinicLocationPatientCreatedAt?: boolean;
  approveInvitationAction?: UseMutationResult<any, Error, any, unknown>;
  approveInvitationCtaLabel?: string;
  showLatestScanDate?: boolean;
  editable?: boolean;
  deletable?: boolean;
  tableHeaders: {
    name: string;
    column: string;
    isSortable: boolean;
  }[];
  onSort?: (orderBy: OrderBy) => void;
  orderBy?: string;
  orderDir?: SortDirection;
  currentSortColumn?: string;
}

const OvClinicLocationUserList: FC<OvClinicLocationUserListProps> = ({
  users,
  clinicLocationId,
  clinicId,
  deleteAction,
  deleteActionCtaLabel,
  seeDetails,
  seeDetailsCtaLabel,
  showClinicRole,
  showClinicLocationProviderCreatedAt,
  showClinicLocationPatientCreatedAt,
  approveInvitationAction,
  approveInvitationCtaLabel,
  showLatestScanDate,
  editable,
  deletable,
  tableHeaders,
  onSort,
  orderBy,
  orderDir,
  currentSortColumn,
}) => {
  const { t } = useTranslation();

  const getSortDirection = (field: string): SortDirection =>
    orderBy === field ? orderDir ?? 'none' : 'none';

  return (
    <>
      <OvListTable>
        <OvListTableRow>
          {tableHeaders.map(({ name, column, isSortable }) => (
            <OvListTableHeaderField
              key={column}
              isSortable={isSortable}
              sortBy={column}
              sortDirection={getSortDirection(column)}
              onSort={onSort}
              isActiveSort={currentSortColumn === column}
              style={{ cursor: 'pointer' }}
            >
              {t(name)}
            </OvListTableHeaderField>
          ))}
        </OvListTableRow>

        {users.map((user) => (
          <OvListTableRow key={user.id}>
            <OvClinicLocationUserListRow
              user={user}
              clinicLocationId={clinicLocationId}
              clinicId={clinicId}
              deleteAction={deleteAction}
              seeDetails={seeDetails}
              seeDetailsCtaLabel={seeDetailsCtaLabel}
              deleteActionCtaLabel={deleteActionCtaLabel}
              showClinicRole={showClinicRole}
              showClinicLocationProviderCreatedAt={
                showClinicLocationProviderCreatedAt
              }
              showClinicLocationPatientCreatedAt={
                showClinicLocationPatientCreatedAt
              }
              approveInvitationAction={approveInvitationAction}
              approveInvitationCtaLabel={approveInvitationCtaLabel}
              showLatestScanDate={showLatestScanDate}
              editable={editable}
              deletable={deletable}
            />
          </OvListTableRow>
        ))}
      </OvListTable>
    </>
  );
};

export default OvClinicLocationUserList;
